import { DeviceActivity } from 'types/DeviceActivity'
import { Device } from 'types/Device'

export const hasAlerts = (device: Device | DeviceActivity, includeNormal = false): boolean => {
  if (!device) return false

  if ('criticalAlarmCount' in device) {
    return (
      device.criticalAlarmCount > 0 ||
      device.sdaCriticalAlarmCount > 0 ||
      device.majorAlarmCount > 0 ||
      device.sdaMajorAlarmCount > 0 ||
      (includeNormal && (device.normalAlarmCount > 0 || device.sdaNormalAlarmCount > 0))
    )
  } else if ('criticalAlertCount' in device) {
    return (
      device.criticalAlertCount > 0 ||
      device.sdaCriticalAlertCount > 0 ||
      device.majorAlertCount > 0 ||
      device.sdaMajorAlertCount > 0 ||
      (includeNormal && (device.minorAlertCount > 0 || device.sdaMinorAlertCount > 0))
    )
  } else {
    return false
  }
}
